import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import classNames from 'classnames';
import { QueueContainer } from 'components/queue';
import { fetchQueueTxnOppsData, setQueueDrawerIsOpen } from 'store/actions';
import { Constants, getModuleByLocation } from 'utilities/constants';

const { UNDERWRITE } = Constants.Routes;

const QueueDrawer = ({
  classes,
  module,
  queueDrawerIsOpen,
  setQueueDrawerIsOpen,
  filteredTasks,
  isPermanent,
  fetchQueueTxnOppsData,
  queueBinsState
}) => {
  const [scrollPosition, setScrollPosition] = React.useState(0);

  useEffect(() => {
    document.addEventListener('keydown', shortCutToggleQueueDrawer);
    return () => document.removeEventListener('keydown', shortCutToggleQueueDrawer);
  }, []);

  useEffect(() => {
    handleDataFetch();
  }, [module]);

  useEffect(() => {
    const isData = queueBinsState?.allTasks?.tasks?.length;
    if ((isPermanent || queueDrawerIsOpen) && !isData) {
      handleDataFetch();
    }
  }, [queueDrawerIsOpen, isPermanent]);

  const shortCutToggleQueueDrawer = args => {
    // Short cut open queue drawer using [ctrl Q]
    if (args.code === 'KeyQ' && args.ctrlKey) {
      setQueueDrawerIsOpen();
    }
  };

  const handleDataFetch = () => {
    fetchQueueTxnOppsData();
  }

  function handleScroll(scroll) {
    setScrollPosition(scroll);
  }

  return (
    <Drawer
      open={queueDrawerIsOpen}
      onClose={() => setQueueDrawerIsOpen(false)}
      variant={isPermanent ? 'permanent' : 'temporary'}
      classes={{
        paper: classNames(classes.drawerPaper, isPermanent && classes.permanentDrawerPaper)
      }}
      ModalProps={{
        disablePortal: true,
        classes: {
          root: classes.drawerModalRoot
        },
        BackdropProps: {
          classes: {
            root: classes.drawerModalBackdropRoot
          }
        }
      }}
    >
      <div
        tabIndex={0}
        role="button"
      >
        <div className={classes.queueContainer} style={{height: isPermanent ? 'calc(100vh - 48px)' : '100vh'}}>
          <QueueContainer
            filteredTasks={filteredTasks}
            handleDataFetch={handleDataFetch}
            handleScroll={handleScroll}
            scroll={scrollPosition}
          />
        </div>
      </div>
    </Drawer>
  )
}

const styles = theme => ({
  queueContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    // height: 'calc(100vh - 48px)',
    paddingTop: '0px',
    backgroundColor: '#f2f2f2',
    display: 'flex',
    flexDirection: 'column',
  },
  drawerPaper: {
    top: 'initial',
    width: 380
  },
  permanentDrawerPaper: {
    zIndex: 1
  },
  drawerModalRoot: {
    position: 'absolute'
  },
  drawerModalBackdropRoot: {
    position: 'absolute'
  }
});

const mapStateToProps = (state, ownProps) => {
  const module = getModuleByLocation(ownProps.location)
  const { queueDrawerIsOpen, filteredTasks, queueBinsState } =  state.queueState[module];
  const hasSelectedTask = module === Constants.Module.POSTACQ ? state.postAcqUWState.postAcqUWClientTask != null : state.propertyUWState.propertyUWClientTxnOpp != null;
  const rootPath = module === Constants.Module.POSTACQ ? Constants.Routes.POSTACQ : Constants.Routes.UNDERWRITE;
  const isRootPath = ownProps.location.pathname.endsWith(rootPath) || ownProps.location.pathname.endsWith(rootPath + '/');
  return {
    module,
    queueDrawerIsOpen,
    filteredTasks,
    queueBinsState,
    isPermanent: !hasSelectedTask && isRootPath
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const module = getModuleByLocation(ownProps.location);
  return {
    setQueueDrawerIsOpen: isOpen => dispatch(setQueueDrawerIsOpen(module, isOpen)),
    fetchQueueTxnOppsData: () => dispatch(fetchQueueTxnOppsData(module))
  }
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(QueueDrawer);